import { Col, Form, Input, Row } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

/**
 * @component
 * @alias AnnaInvoiceInfo
 * @property {boolean} isSupplier
 * @returns overview with AnnaInvoice info
 */
const AnnaInvoiceInfo = ({ isSupplier = false }) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Col span={24}>
        <Form.Item
          name={isSupplier ? "supplier_name" : "recipient_name"}
          label={isSupplier ? t("finance.invoices.supplierName") : t("finance.invoices.recipientName")}
          rules={[{ required: true, message: "" }]}
          initialValue="Andulka services s.r.o."
        >
          <Input disabled={true} bordered={!true}></Input>
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          name={isSupplier ? "supplier_company_number" : "recipient_company_number"}
          label={
            isSupplier ? t("finance.invoices.supplierCompanyNumber") : t("finance.invoices.recipientCompanyNumber")
          }
          rules={[{ required: true, message: "" }]}
          initialValue="28136659"
        >
          <Input.TextArea rows={2} autoSize disabled={true} bordered={!true}></Input.TextArea>
        </Form.Item>
      </Col>
      <Row gutter={[8, 8]}>
        <Col span={12}>
          <Form.Item
            name={isSupplier ? "supplier_address" : "recipient_address"}
            label={isSupplier ? t("finance.invoices.supplierAddress") : t("finance.invoices.recipientAddress")}
            rules={[{ required: true, message: "" }]}
            initialValue="Žižkova tř. 309/12"
          >
            <Input disabled={true} bordered={!true}></Input>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name={isSupplier ? "supplier_postal_code" : "recipient_postal_code"}
            label={isSupplier ? t("finance.invoices.supplierPostalCode") : t("finance.invoices.recipientPostalCode")}
            rules={[
              {
                required: true,
                message: "",
                pattern: new RegExp("[0-9]{4,7}"),
              },
            ]}
            initialValue="37001"
          >
            <Input type={"number"} max={7} min={4} disabled={true} bordered={!true}></Input>
          </Form.Item>
        </Col>
      </Row>
      <Col span={24}>
        <Form.Item
          name={isSupplier ? "supplier_city" : "recipient_city"}
          label={isSupplier ? t("finance.invoices.supplierCity") : t("finance.invoices.recipientCity")}
          rules={[{ required: true, message: "" }]}
          initialValue="České Budějovice"
        >
          <Input disabled={true} bordered={!true}></Input>
        </Form.Item>
      </Col>
    </React.Fragment>
  );
};

export default AnnaInvoiceInfo;
